import React, { useEffect, useState } from 'react'
import "./Reimbursement.css";
import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import api from '../../Authenticaltion/api';
import { toast } from 'react-toastify';
import { MultiSelect } from 'primereact/multiselect';
const AdminReimbursement = () => {
    const [Userreimbursement, setUserreimbursement] = useState([])
    const [ViewDialog, setViewDialog] = useState(false);
    const [SelectedReimbursement, SetSelectedReimbursement] = useState(null);
    const [selectedAction, setSelectedAction] = useState('');
    const [dialogInput, setDialogInput] = useState("");
      const [selectedUserId, setSelectedUserId] = useState(null);
      const [employee, setEmployee] = useState([]);
      const [currentPage, setCurrentPage] = useState(1); // Track the current page
    const [totalPages, setTotalPages] = useState(1); // Track the total pages
    const [limit, setLimit] = useState(30); // Number of items per page
      
    const closeDialog = () => {
        setViewDialog(false);
        setDialogInput('');
        setSelectedAction(''); // Reset the action when closing the dialog
    };

    
      const [filters, setFilters] = useState({
        userIds: [],
        status: null,
  
      });
      const isClearButtonDisabled =
      !filters.userIds.length ;
      const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
    };

    const viewreiumberseDialog = async (select) => {
        console.log("Calling the function", select);
    
        // Open the dialog first without setting SelectedReimbursement initially
      
    
        try {
            // Fetch the specific reimbursement data based on the selected reimbursement ID
            const response = await api.get(`/getReimbursementForEmployee/${select.reimbursement_id}`, {
            });
            console.log("My_Reimbursement", response.data.reimbursements);
            // Set the selected reimbursement data from the API response
            SetSelectedReimbursement(response.data.reimbursements[0]);
           
    
            setViewDialog(true); // Assuming 'reimbursement' is the key holding the data
    
        } catch (error) {
            console.error("Unable to fetch specific reimbursement data", error);
            toast.error('Failed to fetch reimbursement data', {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 1500
            });
        } finally {
            // Reset the action and input state after the API call (whether it succeeds or fails)
            setSelectedAction('');
            setDialogInput('');
        }
    };
    console.log("*****",SelectedReimbursement);
    
    const CloseDialog = () => {
        setViewDialog(false);
        setDialogInput("");
    }
    const fetchUsers = async () => {
    
        try {
          const response = await api.get('/admin-employee');
          if (response.status === 200) {
            const sortedEmployees = response.data.data.sort((a, b) => a.Name.localeCompare(b.Name));
            setEmployee(sortedEmployees);
          } else {
            toast.error('Failed to fetch users', {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 1500
            });
          }
        } catch (error) {
          console.error('Error fetching users:', error);
          toast.error('Error fetching users', {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 1500
          });
        }
      };

    const viewreiumbersements = async () => {
        console.log("Calling the function");
        
        const { userIds } = filters;
        try {
            const params = {
                limit: limit,
                offset: (currentPage - 1) * limit, // Calculate offset based on current page
                employeeIds: userIds,
            };
            const response = await api.get('/newReinversemntDataLimit',{ params });
            console.log("My_Rem", response);    
            setUserreimbursement(response.data.reimbursements);
            setTotalPages(Math.ceil(response.data.totalCount / limit));
        } catch (error) {
            console.error("Unable to fetch Reimbursement data", error);
        }
    }
    const handleReimbursement = (action) => {
        setSelectedAction(action);
    };
    const handleDialogSubmit = async () => {
        setViewDialog(false);

        const formReimbursementData = {
            message: dialogInput,
            status: selectedAction
        };

        try {
            const response = await api.post(`/AssignedOperation/${SelectedReimbursement?.reimbursement_id}`, formReimbursementData);
            toast.success(response.data.message);
            viewreiumbersements();
            closeDialog();
        } catch (error) {
            console.error(error);
        }

        setDialogInput("");
    };
    useEffect(() => {
        fetchUsers();
        viewreiumbersements();
    }, [])
    useEffect(() => {
        viewreiumbersements();
    }, [filters, currentPage, limit]); // Fetch data when filters or currentPage changes
    const clearFilters = () => {
        setSelectedUserId(null);
        setFilters({
          userIds: [],
        });
      };

    return (
        <div class=" shadow p-3 bg-white rounded">
           
            <div className="filter-section   pt-3 " style={{
                      background: 'white',
                      marginTop: '35px',
                    //   borderRadius: '12px',
                    //   boxShadow: '0 2px 12px rgba(0,0,0,0.08)'
                    }}>
                   
                      <div className="row g-3">
                        <div className="col-md-3 mb-2">
                          <MultiSelect
                            value={filters.userIds}
                            options={employee}
                            onChange={(e) => setFilters({ ...filters, userIds: e.value })}
                            optionLabel="Name"
                            optionValue="id"
                            placeholder="Select Users"
                            className="multiselect-custom"
                            display="chip"
                            filter={true}  // Enable filtering
                            filterBy="Name" // Filter by the Name property
                            filterPlaceholder="Search users..." // Add placeholder for search
                            filterMatchMode="contains" // Match anywhere in the text
                            showClear={true} // Show clear button
                            style={{
                              background: 'white',
                              maxHeight: '40px',
                              overflowY: 'auto',
                              whiteSpace: 'nowrap',
                              fontSize: '12px',
                              fontWeight: 'normal'
                            }}
                            panelStyle={{
                              maxHeight: '200px',
                              overflowY: 'auto',
                            }}
                            virtualScrollerOptions={{ itemSize: 43 }} // For better performance with large lists
                          />
                        </div>
                        
                        <div className="col-md-3 mb-2 d-flex justify-content-center align-items-center">
                          <button className="btn btn-danger btn-sm " style={{cursor:'pointer'}} onClick={()=>{
                            clearFilters()
                        
                          }}
                          disabled={isClearButtonDisabled}  >Clear</button>
                        </div>
                      </div>
                    </div>

            <div className="row mt-4">
                {Userreimbursement?.map((Rem_data) => (
                    <div key={Rem_data.reimbursement_id} className="col-xl-3 col-sm-6 mb-4">
                        <div className='card reimbursement-item p-2 leave-item' style={{
                            backgroundColor: '#D1CFCF',
                            cursor: 'pointer',
                            position: 'relative',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                            transition: 'transform 0.3s, box-shadow 0.3s',
                            animation: 'fadeIn 1s',
                            borderRadius: '10px',
                            animationName: 'fadeIn',
                            animationDuration: '1s'
                        }} onClick={() => viewreiumberseDialog(Rem_data)}>
                            <div className='text-center' style={{ backgroundColor: "#ffffff", borderRadius: "5px" }}>
                                <div className='reimbursement_Type p-2' style={{ color: '#2643FF', fontSize: '13px', fontWeight: "700" }}>
                                    {Rem_data.typeName}
                                </div>
                            </div>
                            <div className='row mt-3 flex-grow-1'>
                                <div className='col'>
                                    <div className='reimbursement_Amount'>
                                        <i className="fa fa-rupee" />
                                        <span className='ml-1' style={{ fontSize: "12px", fontWeight: "700" }}>
                                            Amount Spent: <span style={{ color: "red", fontSize: "16px" }}>
                                                {Rem_data.amount}
                                            </span> Rs.
                                        </span>
                                    </div>
                                    <div className='reimbursement_info' style={{ fontSize: "12px" }}>
                                        <i className="fa fa-user" /> {Rem_data.userApplied}
                                    </div>
                                    <div className='reimbursement_info mt-2' style={{ fontSize: "12px" }}>
                                        <i className="fa fa-calendar" />
                                        <span className='ml-1'>Spent on: {Rem_data.date_spent}</span>
                                    </div>
                                    {/* <div className='reimbursement_info' style={{ fontSize: "12px" }}>
                                        <i className="fa fa-calendar" />
                                        <span className='ml-1'>Applied on: {Rem_data.Applied_date}</span>
                                    </div> */}
                                </div>
                                <div className='icon-container justify-content-end' style={{ position: 'absolute', bottom: '10px', right: '10px' }}>
                                    <i className='fas fa-rupee' style={{ fontSize: '4rem', opacity: '0.2' }}></i>
                                </div>
                            </div>

                            <div className={`text-center mt-3 btn pt-1 pb-1 ${Rem_data.final_status === "Pending" ? "bg-warning" : Rem_data.final_status === "Approved" ? "bg-success" : "bg-danger"}`} >
                                <span className='Reimbursement_status text-white'>
                                    {Rem_data.final_status}
                                </span>
                            </div>
                        </div>
                        
                    </div>
                ))}
                {Userreimbursement?.length === 0 && (
                    <div className="col-12">
                        <p className="text-center">Their is no applied reimbursement</p>
                    </div>
                )}
            </div>
            <div className="pagination-controls" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '20px' }}>
                <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} className='btn btn-sm btn-primary'>
                    <i className="fa fa-arrow-left"></i>
                    Previous
                </button>
                <span>Page {currentPage} of {totalPages}</span>
                <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} className='btn btn-sm btn-primary'>
                    Next
                    <i className=" m-1 fa fa-arrow-right"></i>
                  
                </button>
            </div>

            <Dialog
                open={ViewDialog}
                onClose={CloseDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="lg"
            >
                <DialogTitle id="alert-dialog-title">
                    <div className='d-flex justify-content-between align-items-center'>
                        <div className='col text-center text-white'>
                            <span className='h-100 fw-bold' style={{ fontSize: '20px',color: '#021317' }}>{SelectedReimbursement?.typeName}
                            </span>
                        </div>
                        <div className='col-auto'>
                            <IconButton onClick={CloseDialog}>
                                <CloseIcon />
                            </IconButton>
                        </div>
                    </div>
                </DialogTitle>
                <DialogContent dividers>
                    <div className='row'>
                        <div style={{ color: '#021317', fontWeight: "700" }}>
                            <i className="fa fa-rupee" />{' '}
                            <span className='ml-2' style={{ fontSize: "14px", fontWeight: "700" }}>
                                Amount Spent: <span style={{ color: "red", fontSize: "18px" }}>{SelectedReimbursement?.amount}</span> Rs.
                            </span>
                        </div>
                        <div style={{ color: '#021317', fontWeight: "700" }} >
                            <i className='fas fa-calendar-check'></i>
                            <span className='ml-2'>
                                Status:
                                <span style={{ fontSize: "16px", fontWeight: "700" }} className={`status-text ml-2 ${SelectedReimbursement?.final_status === 'Approved' ? 'text-success' :
                                    SelectedReimbursement?.final_status === 'Rejected' ? 'text-danger' :
                                        'text-warning'
                                }`}>
                                    {SelectedReimbursement?.final_status}
                                </span>
                            </span>
                        </div>
                        <div className='mt-2'>
                            <div style={{ color: '#021317', fontWeight: "700" }}>
                                <i className='fa fa-calendar' />
                                <h6 className="d-inline ml-2" style={{ fontSize: "14px" }}>
                                    Spent on: {SelectedReimbursement?.date_spent}
                                </h6>
                            </div>
                            <div style={{ color: '#021317', fontWeight: "700" }}>
                                <i className='fa fa-calendar' />
                                <h6 className="d-inline ml-2" style={{ fontSize: "14px" }}>
                                    Applied on: {SelectedReimbursement?.Applied_date}
                                </h6>
                            </div>
                            <div style={{ color: '#021317', fontWeight: "700" }}>
  <i className="fa fa-file" />
  <h6 className="d-inline ml-2" style={{ fontSize: "14px" }}>
    Document:{" "}
    {SelectedReimbursement?.images && SelectedReimbursement.images.length > 0 ? (
      SelectedReimbursement.images.map((img, index) => (
        <div key={index} style={{ marginTop: "6px" }}>
          <a
            href={img.file_path}
            onClick={(e) => {
              e.preventDefault();
              window.open(img.file_path, "_blank");
            }}
            role="button"
            target="_blank"
            aria-label={`Download ${img.original_filename}`}
            style={{ color: '#6366F1', fontWeight: 'bold' }}
            rel="noreferrer"
          >
            {img.original_filename}
            <i className="fa fa-download ml-1"></i>
          </a>
        </div>
      ))
    ) : SelectedReimbursement?.file_path ? (
      <a
        href={SelectedReimbursement.file_path}
        onClick={(e) => {
          e.preventDefault();
          window.open(SelectedReimbursement.file_path, "_blank");
        }}
        role="button"
        target="_blank"
        aria-label={`Download ${SelectedReimbursement.original_filename}`}
        style={{ color: '#6366F1', fontWeight: 'bold' }}
        rel="noreferrer"
      >
        {SelectedReimbursement.original_filename}
        <i className="fa fa-download ml-1"></i>
      </a>
    ) : (
      "Not provided"
    )}
  </h6>
</div>

                        </div>
                    </div>
                    <div>
                        <h5 className="mt-4 ml-2 " style={{ color: '#021317', fontWeight: "700" }}>Apply History</h5>
                    </div>
                    <div class=" card chat-history mt-2" style={{ backgroundColor: '#F9FCFF' }}>
                        <div>
                            <ul className="list-unstyled">
                                <li>
                                    <div className="d-flex flex-column mt-3">
                                        <div className="d-flex align-items-center ml-3" style={{ fontSize: "12px", color: "#6366F1" }}>
                                            <strong> {SelectedReimbursement?.statusHistory[0].updated_by}</strong>
                                            <div className="message-data-time ml-2">
                                                {SelectedReimbursement?.statusHistory[0].date_changed}
                                            </div>
                                        </div>
                                        <div className="d-flex mt-1 ml-2">
                                            <div>
                                                <img
                                                    src={SelectedReimbursement?.statusHistory[0].user_image || `/images/icon/Noprofile.webp`}
                                                    className="rounded-circle mr-2"
                                                    style={{ width: "50px", height: "50px", objectFit: "cover" }}
                                                    alt="avatar"
                                                />
                                            </div>
                                            <div
                                                className="card message other-message p-2 ml-2 mr-4"
                                                style={{ backgroundColor: "#A4A6A8", color: "#000000" }}
                                                dangerouslySetInnerHTML={{ __html: SelectedReimbursement?.statusHistory[0].message }}
                                            />
                                        </div>
                                    </div>
                                </li>
                                {SelectedReimbursement?.statusHistory.map((historyItem, index) => (
                                    index >= 1 && (
                                        <li className="clearfix mt-2 d-flex justify-content-end ml-auto mr-3" key={index}>
                                            <div className="d-flex flex-column align-items-end mt-3">
                                                <div className="d-flex align-items-center mr-3" style={{ fontSize: "12px", color: "#6366F1" }}>
                                                    <div className="message-data-time mr-2">
                                                        {historyItem.date_changed}
                                                    </div>
                                                    <strong>{historyItem.updated_by}</strong>
                                                </div>
                                                <div className="d-flex mt-1">
                                                    <div
                                                        className="card message other-message p-2"
                                                        style={{ backgroundColor: "#A4A6A8", color: "#000000" }}
                                                        dangerouslySetInnerHTML={{ __html: historyItem.message }}
                                                    />
                                                    <div>
                                                        <img
                                                            src={historyItem.user_image || `/images/icon/Noprofile.webp`}
                                                            className="rounded-circle ml-2"
                                                            style={{ width: "50px", height: "50px", objectFit: "cover" }}
                                                            alt="avatar"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    )
                                ))}
                            </ul>
                        </div>
                    </div>
                    {SelectedReimbursement?.final_status === "Pending" && (
                        <div>
                            <div className="d-flex justify-content-end">
                                <button type="button" className="btn btn-success me-2" onClick={() => handleReimbursement('Approved')}>Approve</button>
                                <button type="button" className="btn btn-danger" onClick={() => handleReimbursement('DisApproved')}>Reject</button>
                            </div>
                            {selectedAction && (
                                <div className="card mt-2 p-2">
                                    <textarea
                                        className="form-control mt-2"
                                        value={dialogInput}
                                        placeholder="Enter Message Here"
                                        onChange={(e) => setDialogInput(e.target.value)}
                                        style={{ height: '100px' }}
                                    />
                                    <div className="d-flex justify-content-center mt-2">
                                        <button
                                            type="button"
                                            className="btn btn-primary"
                                            onClick={handleDialogSubmit}
                                        >
                                            Submit
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </DialogContent>
            </Dialog>

        </div>
    )
}

export default AdminReimbursement
